import { iconos } from "../../../assets";

export const items = [
  {
    id: 1,
    icon: iconos.staffing.src,
    title: "Staffing",
    resume:
      "Incorpore desarrolladores experimentados rápidamente a su equipo a lo largo del periodo que usted desee y necesite.",
    cuando:
      "Necesita cubrir necesidades de desarrollo, no dispone de tiempo para largos periodos de contratación",
    beneficio: "Aumente o disminuya su equipo según sus necesidades",
  },
  {
    id: 2,
    icon: iconos.equipos.src,
    title: "Equipos dedicados",
    resume:
      "Incorpore desarrolladores experimentados rápidamente a su equipo a lo largo del periodo que usted desee y necesite.",
    cuando:
      "Necesita cubrir necesidades de desarrollo, no dispone de tiempo para largos periodos de contratación",
    beneficio: "Aumente o disminuya su equipo según sus necesidades",
  },
  {
    id: 3,
    icon: iconos.llave.src,
    title: "Llave en mano",
    resume:
      "Enfóquese en su negocio y delegue su proyecto tecnológico. Sea un proyecto nuevo o acelerar uno existente.",
    cuando:
      "Dispone presupuesto y de metas definidas, Especificaciones del software que necesita definidas",
    beneficio:
      "Comienzo del desarrollo en corto plazo, costo predefinidos, olvidese de riesgos de gestión",
  },
];
